var render = function render(){var _vm=this,_c=_vm._self._c;return _c('KLogo',{attrs:{"altText":"Kolibri logo - monoBlack","size":120,"showBackground":true,"colorScheme":"monoBlack"}})
}
var staticRenderFns = []

export { render, staticRenderFns }